export default {
    DEPENDENTE_SAFRISTA: 1,
    ESTUDANTE: 2,
    TURISTA: 3,
    TEMPORARIO: 4,
    SAFRISTA: 5,
}